import { useCallback } from 'react'

import { DownloadIcon, RecordIcon } from '@verbit-ai/icons-library'

import * as S from './styles'

export const MockRecordController = () => {
    const onDownload = useCallback(() => {
        document.mocks.downloadMock()
    }, [])

    return (
        <>
            <S.RecordIconWrapper>
                <RecordIcon />
            </S.RecordIconWrapper>
            <S.Button onClick={onDownload}>
                <DownloadIcon /> Download Mock file
            </S.Button>
        </>
    )
}
